/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyResource } from '../models/CompanyResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AuthService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Se deconnecter
     * Revoque le token utilise pour l'appel. Les autres appareils restent connectes.
     * @returns any
     * @throws ApiError
     */
    public logout(): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/logout',
        });
    }
    /**
     * Obtenir un token depuis Lola
     * Ouvre Lol@pp depuis le logiciel Lola sans ressaisir de mot de passe : echange les identifiants transmis par Lola contre un token personnel.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public authGetTokenFromLola(
        requestBody: {
            client_id: string;
            client_secret: string;
            id_personnel?: string;
        },
    ): CancelablePromise<{
        access_token: string;
        token_type: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/token/lola',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Entreprise courante
     * La fiche de l'entreprise identifiee par `Company-Key` : nom, cle, couleurs, images, avis Google... Sert au demarrage de l'application, avant toute connexion.
     * @returns CompanyResource `CompanyResource`
     * @throws ApiError
     */
    public authGetCurentCompany(): CancelablePromise<CompanyResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/lolapp/start',
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Obtenir un token personnel
     * Connexion d'un utilisateur Lol@pp : `password` et soit `email`, soit `IDPERSONNEL`. Renvoie `{ token, tokenable_type, tokenable_id, company_id }` ; le token se passe ensuite en `Authorization: Bearer`. 422 si l'identifiant ou le mot de passe est faux, 403 si l'entreprise est desactivee. Exige `Company-Key` mais aucun token.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public authCreatePersonnelToken(
        requestBody: {
            IDPERSONNEL?: number | null;
            email?: string | null;
            password: string;
        },
    ): CancelablePromise<{
        token: string;
        tokenable_type: string;
        tokenable_id: string;
        company_id: number;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/lolapp/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Demander la reinitialisation du mot de passe
     * Envoie a `MAIL` (adresse d'un personnel de l'entreprise, 404 sinon) un lien de reinitialisation valable 60 minutes. Reponse : `{ message }`.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public passwordEmail(
        requestBody: {
            MAIL: string;
        },
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/password/email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Reinitialiser le mot de passe
     * Avec le `token` du lien recu par e-mail, l'`email` et le nouveau `password` (8 caracteres minimum, confirme par `password_confirmation`). 400 `{ message }` si le lien est invalide ou expire, ou si le mot de passe est trop faible.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public passwordReset(
        requestBody: {
            token: string;
            email: string;
            password: string;
            password_confirmation: string;
        },
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/password/reset',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
}
